import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Typography,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle
} from '@material-ui/core'
import { create, resetDraws } from '~/state/modules/draws'
import { loadTicketByUsage, loadEvent } from '~/state/modules/events'
import { PaperContainer } from '~/views/shared'
import { EventDrawForm } from 'views/pages/EventsPage/components/EventDrawForm'
import { ROUTES } from '~/views/routes'
import { useStyles } from './DrawsCreatePage.style'
import history from '~/config/history'
import { TICKET_USAGE } from 'config/constants'
import * as moment from 'moment'
import { showSnackbarError } from 'views/utils/snackbar'

export const DrawsCreatePage = ({ match, onSuccess }) => {
  const classes = useStyles()
  const { pending, actionPending, actionSuccess } = useSelector(
    (state) => state.draws
  )
  const {
    event,
    ticketList,
    pending: pendingTickets
  } = useSelector((state) => state.events)

  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
    onSuccess(match.params.eventId)
  }

  const dispatch = useDispatch()

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadTicketByUsage(match.params.eventId, TICKET_USAGE.DRAW))
      await dispatch(loadEvent(match.params.eventId))
    }
    fetchData().then()

    return () => {
      dispatch(resetDraws())
    }
  }, [dispatch, match])

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true)
      if (values.TicketsAmount === '') {
        values.TicketsAmount = 1
      }
      await dispatch(create(values))
      setOpen(true)
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSubmitting(false)
    }
  }

  const values = {
    Title: '',
    Description: '',
    TicketsAmount: 0,
    TicketTypeId: '',
    ScheduledOn: moment(event?.StartDateTime).subtract(3, 'hours')
  }

  return (
    <>
      {event && (
        <Typography variant='h6' className={classes.eventTitle}>
          {`${event?.Title} (${event?.Id})`}{' '}
        </Typography>
      )}
      <PaperContainer title='Creación de sorteo'>
        {pending || pendingTickets ? (
          <CircularProgress size={24} color='secondary' />
        ) : (
          <EventDrawForm
            values={values}
            ticketList={ticketList}
            actionText='Crear'
            handleSubmit={handleSubmit}
            actionPending={actionPending}
            actionSuccess={actionSuccess}
            onCancel={() =>
              history.push(
                ROUTES.ADMIN.EVENTS.DRAWS.INDEX.replace(
                  ':eventId',
                  match.params.eventId
                )
              )
            }
          />
        )}
      </PaperContainer>
      <Dialog open={open}>
        <DialogTitle>Sorteo Creado!</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color='primary' autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DrawsCreatePage
